import customHeaders, { getSpace } from '../../../common/headers';
import "./ModalReturns.scss"
import { useResponseHandler } from '../../../common/auth'
import useGeneralStore from '../../../store/general';
import { useEffect, useState } from 'react';
import { CardReturn } from '../CardReturn/CardReturn';
import { ModalComponent } from '../../../components/Modal/ModalComponent/ModalComponent';

const ModalReturns = ({
    current,
    setIsModal
}) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };

    const { handleTableResponse, handleRequestError } = useResponseHandler();
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const fetchGetData = (abortController = new AbortController()) => {
        setLoading(true)
        let url = `https://apps2.ecomru.ru:4655/v1/returns/get`;

        const body = JSON.stringify({
            mp_id: current?.mp_id,
            api_id: current?.api_id,
            return_id: current?.return_id
        });

        fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
            .then(handleTableResponse)
            .then((json) => setData(json))
            .catch(handleRequestError)
            .finally(() => {
                if (abortController.signal.aborted) return
                setLoading(false)
            })
    };

    useEffect(() => {
        if (current?.return_id) {
            fetchGetData()
        }
    }, [current]);

    return (
        <ModalComponent
            title={<>Решение по возврату <span style={{ color: '#00B45E' }}>ID-{current?.return_id}</span></>}
            onClose={(e) => setIsModal(false)}
            loading={loading}
            child={
                <div className='modal-returns'>
                    <CardReturn ret={data} />
                </div>
            }
        />
    )
}

export { ModalReturns }